import * as Styled from './styles'

interface IOnboardingAvatarImageProps {
  useImageWithGrayBorder?: boolean
}

export const OnboardingAvatarImage = (props: IOnboardingAvatarImageProps) => {
  return (
    <Styled.ImagePhone withGrayBorder={props.useImageWithGrayBorder || false} data-testid="onboarding-avatar-image" />
  )
}
